import React from 'react';

export const ModuleAccess = (module, permission) => {
    var modules = {
        'RXM': {
         'SUPADM': [''],
            'SBPFADM': [''],
        },
        'DB': {
            'SUPADM': [''],
            'SBPFADM': ['',],
        },
        'PCO': { 
            'SUPADM': ['CO','VW','AD','ED','AO','CMPO','AT','EX','RE','UP'],
            'SBPFADM': ['CO','VW','AD','ED','AO','CMPO','AT','EX','RE','UP'],
            'SBADM': ['CO','VW','AD','ED','AO','CMPO','AT','EX','UP'],
            'SBCEU': ['CO','VW','AD','ED','AO','CMPO','AT','EX','UP'],
            'SBCEVO': ['VW','EX'],
            'SBBU': ['CO','VW','AD','ED','AO','CMPO','AT','EX','UP'],
            'SBCSAD': ['CO','VW','AD','ED','AO','CMPO','AT','EX','UP'],
            'SBCSUS': ['CO','VW','AD','ED','AO','CMPO','AT','EX','UP'],
            'SBCSVO': ['VW','EX']

             },
        'ACC': { 
           'SUPADM': ['AD','ED','VW','EX'],
            'SBPFADM': ['AD','ED','VW','EX'],
            'SBADM': ['AD','ED','VW','EX'],
            'SBCEU': ['AD','ED','VW','EX'],
            'SBCEVO': ['VW','EX'],
            'SBBU': ['VW','EX'],
            'SBCSAD': ['AD','ED','VW','EX'],
            'SBCSUS': ['AD','ED','VW','EX'],
            'SBCSVO': ['VW','EX']
            },
        'CRW': {        
            'SUPADM': ['AD','ED','DE','VW','MP','EX','HI','UHI','HD'],
            'SBPFADM': ['AD','ED','DE','VW','MP','EX','HI','UHI','HD'],
            'SBADM':  ['AD','ED','VW','MP','EX','HI','UHI','HD'],
            'SBCEU':  ['AD','ED','VW','MP','EX','HI','UHI','HD'],
            'SBCEVO': ['VW','EX'],
            'SBBU': ['VW','EX'],
            'SBCSAD': ['AD','ED','VW','MP','EX','HI','UHI','HD'],
            'SBCSUS': ['AD','ED','VW','MP','EX','HI','UHI','HD'],
            'SBCSVO': ['VW','EX']
         },
        'DRC': { 
         'SUPADM':  ['ED','VW','EX'],
            'SBPFADM':   ['ED','VW','EX'],
            'SBADM':   ['ED','VW','EX'],
            'SBCEU':   ['ED','VW','EX'],
            'SBCEVO': ['AD','VW','EX'],
            'SBBU': ['AD','VW','EX'],
            'SBCSAD':   ['ED','VW','EX'],
            'SBCSUS':    ['ED','VW','EX'],
            'SBCSVO': ['AD','VW','EX']
            },
        'REP': {  
            'SUPADM': ['VW','EX'],
            'SBPFADM': ['VW','EX'],
            'SBADM': ['VW','EX'],
            'SBCEU': ['VW','EX'],
            'SBCEVO': ['VW','EX'],
            'SBBU': ['VW','EX'],
            'SBCSAD': ['VW','EX'],
            'SBCSUS': ['VW','EX'],
            'SBCSVO': ['VW','EX']
          
             },
        'CON': { 
            'SUPADM':  ['AD','ED','VW','EX'],
            'SBPFADM':   ['AD','ED','VW','EX'],
            'SBADM':   ['AD','ED','VW','EX'],
            'SBCEU':  ['VW','EX'],
            'SBCEVO': ['VW','EX'],
            'SBBU': [''],
            'SBCSAD':  ['AD','ED','VW','EX'],
            'SBCSUS':   ['VW','EX'],
            'SBCSVO': ['VW','EX']
         },
        'ADT': { 
            'SUPADM':  ['AD','ED','DE','AT','EX','GN','VW','DT'],
            'SBPFADM':  ['AD','ED','DE','AT','EX','GN','VW','DT'],
            'SBADM':  ['AD','ED','DE','AT','EX','GN','VW', 'DT'],
            'SBCEU':  ['AD','ED','AT','EX','GN','VW', 'DT'],
            'SBCEVO': ['VW','EX'],
            'SBBU': [''],
            'SBCSAD': ['AD','ED','DE','AT','EX','GN','VW','DT'],
            'SBCSUS':  ['AD','ED','AT','EX','GN','VW', 'DT'],
            'SBCSVO': ['VW','EX']
         }
    };

    const { access_token } =
        JSON.parse(localStorage.getItem('pharmaforce')) || {};
    let userRoles = [];
    if (access_token) {
        let jwtData = access_token.split('.')[1]
        let decodedJwtJsonData = window.atob(jwtData)
        let decodedJwtData = JSON.parse(decodedJwtJsonData)
        userRoles = decodedJwtData['roles'];
    }

    //console.log(module);
    var roles = modules[module];
    //console.log(roles);
    var permissions = [];
    if (Array.isArray(userRoles)) {
        for (var i = 0; i < userRoles.length; i++) {
            var userRole = userRoles[i];
            //console.log(userRole);
            var userper = roles[userRole];
            //console.log(userper);
            permissions = permissions.concat(userper);
        }
    }
    else {
        var userper = roles[userRoles];
        if (userper)
            permissions = permissions.concat(userper);
    }

    //console.log(permissions);
    if (!permission)
        return permissions.length > 0;
    return permissions.indexOf(permission) != -1;
}